
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { languageModule } from '@/store/languages';

@Options({
  name: ''
})
export default class AsyncComponentWrapper extends Vue {
  @Prop({ type: Object })
  component!: any;

  @Prop({ type: Object })
  promise!: Promise<any>;

  @Prop({ type: String })
  promiseTargetProperty!: string;

  @Prop({ type: String, default: '' })
  loadingError!: string;

  loadingPlaceholder: string = '...';
  loaded = false;
  value: any = null;

  get props() {
    return {
      ...this.$props,
      [this.promiseTargetProperty]: this.value,
    };
  }

  created() {
    this.promise.then((v: any) => {
      this.value = v;
      this.loaded = true;
    }).finally(() => {
      this.loadingPlaceholder = this.loadingError || this.$t('common.error_loading');
    });
  }

}
